import formats from '../../api/formats'
import dialogs from '../common/dialogs.js'
import store from '../../store'
import AssistClasses from '../assist/AssistClasses.js'
// import client from '../client'

class Strategy extends AssistClasses.Strategy {
  constructor (cxt) {
    super(cxt)
    this.chipsItems = []
    this.pProps = null
  }
  getTypeCode () {
    return 'CLIENT_MAILBOX'
  }
  getTypeName () {
    return 'Почтовый ящик'
  }
  setContext (cxt) {
    this.context = cxt
  }
  setParentProps (pProps) {
    this.pProps = pProps
  }
  createModel () {
    var model = new Model()
    return model
  }
  createModelFromJSON (json) {
    return Object.assign(this.createModel(), JSON.parse(json))
  }
  createDefaultModel (parent) {
    return Object.assign(this.createModel(), {})
  }
  createModelFromData (data) {
    return Object.assign(this.createModel(), data)
  }
  updateSteps (scheme) {
    const emailRules = v => !v || formats.isEmail(v) || 'Неверный формат адреса Эл.почты'

    let steps = []
    new AssistClasses.Step(
      '',
      (step) => {},
      {
        scheme: [
          {
            fieldType: 'v-text-field',
            label: 'Название',
            name: 'name',
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-select',
            label: 'Режим',
            name: 'mode',
            itemText: 'text',
            itemValue: 'value',
            items: [
              {value: 'OUT', text: 'Только отсылка'},
              {value: 'ALL', text: 'Доступ к письмам'},
              {value: 'DIF', text: 'Специальные параметры'}
            ],
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Исходящий сервер',
            name: 'host',
            grow: true,
            size: {sm8: true, xs8: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Порт',
            name: 'port',
            grow: true,
            size: {sm4: true, xs4: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Пользователь',
            name: 'username',
            hint: 'С этого адреса отправляется почта',
            rules: Array.of(emailRules),
            grow: true,
            size: {sm8: true, xs8: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Пароль',
            name: 'pwd',
            type: 'password',
            hint: 'Пароль хранится в шифрованном виде',
            grow: true,
            size: {sm4: true, xs4: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Скрытая копия',
            name: 'bcc',
            hint: 'Адрес для скрытых копий всех писем компании, копия посылается на рабочий адрес отправителя',
            rules: Array.of(emailRules),
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Адрес для ответа',
            name: 'replyTo',
            hint: 'Адрес будет подставляться при использовании \'Ответить\' адресатом',
            rules: Array.of(emailRules),
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Сервер писем  (IMAP-сервер)',
            name: 'hostIn',
            if: (model, field) => ['DIF'].includes(model['mode']),
            grow: true,
            size: {sm8: true, xs8: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Порт',
            name: 'portIn',
            if: (model, field) => ['DIF'].includes(model['mode']),
            grow: true,
            size: {sm4: true, xs4: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Пользователь',
            name: 'usernameIn',
            hint: 'Доступ к письмам на почтовом сервере',
            rules: Array.of(emailRules),
            if: (model, field) => ['DIF'].includes(model['mode']),
            grow: true,
            size: {sm8: true, xs8: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Пароль',
            name: 'pwdIn',
            type: 'password',
            hint: 'Пароль хранится в шифрованном виде',
            if: (model, field) => ['DIF'].includes(model['mode']),
            grow: true,
            size: {sm4: true, xs4: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Отправленные',
            name: 'outbox',
            hint: 'Папка на сервере для отправленных писем',
            if: (model, field) => ['ALL', 'DIF'].includes(model['mode']),
            grow: true,
            size: {sm6: true, xs12: true}
          },
          {
            fieldType: 'v-text-field',
            label: 'Входящие',
            name: 'inbox',
            hint: 'Папка на сервере для входящих писем',
            if: (model, field) => ['ALL', 'DIF'].includes(model['mode']),
            grow: true,
            size: {sm6: true, xs12: true}
          }
        ]
      },
      {
      }).addToArray(steps)

    this.steps = steps
    return this
  }
  viewNumber (model) {
    return model['name'] ? model['name'] : '-'
  }
  viewTitle (model) {
    if (this.parent) {
      return `Банковские реквизиты ${this.pProps.companyNameShort}`
    }
    return this.getTypeName()
  }
  viewTitleComp (model) {
    return formats.createComp(`
      <span>${model['name'] ? model['name'] : this.getTypeName()}</span>
    `)
  }
  viewContentComp (model) {
    const _f = (v) => v || '-'
    let value = this.viewContent(model)
    let caption = `
      <span>
        <span><b>${_f(model['name'])}</b></span>
        <span>Исходящий сервер:<b>${_f(model['host'])}</b></span>
        <span>Входящий сервер: <b>${_f(model['hostIn'])}</b></span>
      </span>
    `
    return {
      template: `<span><component :is="renderValueLink()"></component></span>`,
      methods: {
        renderValueLink () {
          return store.getters.renderValueLink(value, null, null, null, caption)
        }
      }
    }
  }
  viewContent (model) {
    const _f = (v) => v || '-'
    return `
        ${_f(model['name'])}
        исходящий: ${_f(model['username'])}
        входящий: ${_f(model['usernameIn'])}
    `
  }
  updateModel (model) {
    this.steps.forEach((step) => step.setModel(model))
  }
  fetchData (itemId) {
    return new Promise((resolve, reject) => {
      if (itemId) {
        this.context.$store.dispatch('getClientMailbox', itemId).then(data => {
          data.mode = data.mode || 'OUT'
          data.portIn = data.portIn || '993'
          data.hostIn = data.hostIn || data.host
          data.usernameIn = data.usernameIn || data.username
          data.inbox = data.inbox || 'Inbox'
          data.outbox = data.outbox || 'Sent'
          resolve(data)
        })
      } else {
        let def = {
          mode: 'OUT',
          host: 'smtp.mail.ru',
          port: '587',
          username: '[Почтовый ящик]@mail.ru'
        }
        resolve(def)
      }
    })
  }
  updateData (itemId, model, parentId) {
    let item = model
    item['id'] = itemId
    if (this.pProps) {
      item['clientId'] = this.pProps.clientId
    }
    return new Promise((resolve, reject) => {
      this.context.$store.dispatch('updateClientMailbox', {dto: item}).then(id => {
        resolve(id)
      })
    })
  }
  deleteData (itemId, model) {
    return new Promise((resolve, reject) => {
      dialogs.confirm(this.context,
        'Подтвердите',
        `Удалить почтовый ящик?`,
          (self) => {
            self.$store.dispatch('deleteClientMailbox', {ids: [itemId]})
              .then(() => resolve())
          })
    })
  }
}

class Model {
  constructor () {
    this.modelType = '213.01'
  }
}

function createStrategy (cxt) {
  return new Strategy(cxt)
}

export default {
  createStrategy,
  Model
}



// WEBPACK FOOTER //
// ./src/components/client/ClientMailbox.js